import { Navigate } from 'react-router-dom';

import { SmallSpinner } from '../features/common';
import useIsRegionalHubClouder from '../hooks/useIsRegionalHubClouder';
import { ORDERS_HOME_PATH } from '../hooks/useClouderHomePath';

export default function RegionalHubRoutesGuard({ children }) {
  const { isRegionalHubClouder, isLoading } = useIsRegionalHubClouder();

  if (isLoading) {
    return <SmallSpinner />;
  }

  if (isRegionalHubClouder) {
    return <Navigate to={ORDERS_HOME_PATH} replace />;
  }

  return children;
}
